
<section class="hero-height">
    <div class="bg-hero d-flex align-items-center hero-height">
        <div class="container">
            <div class="row">
                <div class="col-lg-4"></div>
                <div class="col-lg-4" >
                    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login pass mb-4">
                        <div class="form-control">
                            <p class="mb-1 text-white" style="font-weight: bold;">Nueva contraseña</p>
                            <input type="password" formControlName="password" class="w-100">
                            <div class = "alert alert-primary" *ngIf="submitted && f.password.errors" >
                                <div *ngIf="f.password.errors.required">Contraseña es requerida.</div>
                              </div>
                        </div>
                        <div class="form-control">
                            <p class="mb-1 text-white" style="font-weight: bold;">Confirmar contraseña</p>
                            <input type="password" formControlName="confirmPassword" class="w-100">
                            <div  class = "alert alert-primary" *ngIf="submitted && f.confirmPassword.errors">
                                <div  *ngIf="f.confirmPassword.errors.required">Confirmar contraseña es requerido.</div>
                                <div *ngIf="f.confirmPassword.errors.confirmedValidator">Repita su contraseña. No coinciden</div>
                              </div>
                        </div>
                        <div class="form-control text-center mt-4">
                            <button type="submit" class="align-self-center border-2 btn btn-lg btn-primary btn-reservar rounded-pill text-center">Modificar contraseña</button>
                        </div>
                    </form>              
                </div>
                <div class="col-lg-4"></div>
            </div>
        </div>
    </div>
</section>
